import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/happy-new-year',
      name: 'finale',
      component: () => import('@/views/Finale.vue')
    },
    {
      path: '/:slug',
      name: 'single-card',
      component: () => import('@/views/SingleCard.vue')
    }
  ]
})
